import axios from 'axios';
import { apiConfig } from '../config/amplify';

/**
 * API client for RDD backend
 */
class RDDApiClient {
  constructor() {
    this.baseURL = apiConfig.baseURL;
    this.client = axios.create({
      baseURL: this.baseURL,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  /**
   * Set authorization token for requests
   */
  setAuthToken(token) {
    if (token) {
      this.client.defaults.headers.common['Authorization'] = token;
    } else {
      delete this.client.defaults.headers.common['Authorization'];
    }
  }

  /**
   * Health check
   */
  async checkHealth() {
    const response = await this.client.get('/health');
    return response.data;
  }

  /**
   * Get scripts available to user
   * @param {string} email - Optional email to query (admin only)
   */
  async getScripts(email = null) {
    const params = email ? { email } : {};
    const response = await this.client.get('/scripts', { params });
    return response.data;
  }

  /**
   * Execute a script
   * @param {string} scriptId - Script ID to execute
   * @param {string} targetEmail - Target user email (optional, defaults to caller)
   * @param {string} targetEnv - Target environment (optional, defaults to prod)
   * @param {object} params - Script parameters
   */
  async executeScript({ scriptId, targetEmail, targetEnv, params }) {
    const response = await this.client.post('/run', {
      scriptId,
      targetEmail,
      targetEnv,
      params
    });
    return response.data;
  }

  /**
   * Update user script access (admin only)
   * @param {string} targetEmail - User email
   * @param {string} scriptId - Script ID
   * @param {boolean} enabled - Enable or disable
   * @param {array} allowedEnvs - Optional allowed environments
   */
  async updateEnablement({ targetEmail, scriptId, enabled, allowedEnvs }) {
    const response = await this.client.put('/admin/enablements', {
      targetEmail,
      scriptId,
      enabled,
      allowedEnvs
    });
    return response.data;
  }
}

export const apiClient = new RDDApiClient();
